module.exports = __webpack_public_path__ + "img/Icon - Download.fc82e652.svg";